<template>
	<div class="flex flex-col gap-3 bg-white p-2">
		<div class="flex items-center font-semibold gap-2">
			<div>{{ $t(getStatus.value) }}</div>
			<div>({{ orders.length }})</div>
		</div>

		<div class="inner-column">
			<div v-for="order in orders" :key="order.orderID">
				<statuses-card
					:order="order"
					:is-selected="selectedOrderId === order.orderID"
					:label="getStatus.action"
					@answer="$emit('answer', order)"
					@cookOrder="$emit('cookOrder', order)"
					@deliverOrder="$emit('deliverOrder', order)"
				/>
			</div>
		</div>
	</div>
</template>

<script>
	import statusesCard from '../OrderStatusesCard';
	import { kanbanColumns } from '@/constants/kanban';

	export default {
		name: 'KanbanColumn',
		emits: ['click', 'onStatusChange', 'onAssignCourier', 'orderClick', 'answer', 'cookOrder', 'deliverOrder'],
		components: {
			statusesCard,
		},
		props: {
			status: {},
			orders: {},
			selectedOrderId: {},
		},
		computed: {
			getStatus() {
				const status = kanbanColumns.find((orderStatus) => {
					return orderStatus.value === this.status;
				});
				if (!status) {
					return {};
				}
				return status;
			},
		},
	};
</script>

<style scoped></style>
